<div class="global-overlay-page">
  <div style="display: flex; justify-content: center; padding: 20px;">
    <div style="width: 100%">

      <div class="menu">
        <input type="text" (keyup)="filter($event)" [value]="filterValue" placeholder="Filter tags" />
        <button class="btn-create" (click)="createTag()">
          <mat-icon class="btn-create-icon">add</mat-icon>
          New tag
        </button>
      </div>

      <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="tag">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Tag</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="tag-pill">{{ element.tag }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="clients">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Clients</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.clients }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="users">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Users</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.users | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="reports">
          <mat-header-cell *matHeaderCellDef>Reports</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button class="reports-btn"
              [attr.popovertarget]="'reports-' + element.id"
              (click)="positionPopover('reports-' + element.id, $event)">
              <mat-icon class="reports-btn-icon">assessment</mat-icon>
              Reports
              <mat-icon class="reports-btn-chevron">expand_more</mat-icon>
            </button>
            <div [id]="'reports-' + element.id" popover class="row-popover-menu">
              <a class="popover-item" (click)="gotoReport(element.id, 'completion', $event, element.tag)">
                <mat-icon class="popover-item-icon">check_circle_outline</mat-icon> Completion
              </a>
              <a class="popover-item" (click)="gotoReport(element.id, 'actions', $event, element.tag)">
                <mat-icon class="popover-item-icon">bolt</mat-icon> Actions
              </a>
              <a class="popover-item" (click)="gotoReport(element.id, 'feedback', $event, element.tag)">
                <mat-icon class="popover-item-icon">chat_bubble_outline</mat-icon> Feedback
              </a>
              <a class="popover-item" (click)="gotoReport(element.id, 'reflections', $event, element.tag)">
                <mat-icon class="popover-item-icon">menu_book</mat-icon> Reflections
              </a>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button class="menu-trigger"
              [attr.popovertarget]="'actions-' + element.id"
              (click)="positionPopover('actions-' + element.id, $event)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <div [id]="'actions-' + element.id" popover class="row-popover-menu">
              <a class="popover-item" (click)="renameTag(element, $event)">Rename</a>
              <div class="popover-divider"></div>
              <a class="popover-item danger" (click)="startDelete(element, $event)">Delete tag</a>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div style="display: flex; justify-content: center;">
        <mat-paginator
          [length]="count"
          [pageIndex]="page"
          [pageSize]="size"
          (page)="onPaginateChange($event)"
          showFirstLastButtons
          hidePageSize="true">
        </mat-paginator>
      </div>

    </div>
  </div>

  @if (deletingTag) {
  <div class="delete-overlay" (click)="cancelDelete($event)">
    <div class="delete-modal" (click)="$event.stopPropagation()">
      <div class="delete-modal-close">
        <button (click)="cancelDelete()">×</button>
      </div>
      <div class="delete-modal-title">Deleting a tag is irreversible!</div>
      <div class="delete-modal-body">
        This will remove <strong>{{ deletingTag.tag }}</strong> from
        <strong>{{ deletingTag.clients }}</strong> clients. Type the tag name below to confirm.
      </div>
      <div class="delete-modal-input-wrap">
        <div class="delete-modal-label">Confirm tag name</div>
        <input
          type="text"
          [placeholder]="deletingTag.tag"
          [(ngModel)]="deleteConfirmName"
          class="delete-modal-input" />
      </div>
      <div class="delete-modal-footer">
        <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
        <button class="btn-ok" [disabled]="!deleteConfirmValid" (click)="confirmDelete()">OK</button>
      </div>
    </div>
  </div>
  }
</div>
